<div class="card" [formGroup]="form">

  <div class="float-start card-header card-header-detail" i18n>Ggf. Einreisegenehmigung für das Endbestimmungsland</div>

  <div class="card-body">

    <div class="row">

      <div class="col-md-4">
        <div class="mb-3">
          <label for="antragsteller.einreisegenehmigung.endzielStaat" i18n [class.mandatory]="isMandatory('endzielStaat')">Endzielstaat:</label>
          <select id="antragsteller.einreisegenehmigung.endzielStaat"
                  class="form-select form-select-sm"
                  [class.is-invalid]="errorClassRequired(form.controls['endzielStaat'])"
                  formControlName="endzielStaat"
                  [ngbPopover]="popover_antragsteller_einreisegenehmigung_endzielStaat"
                  appSaveLastFocussed
          >
            <option value="" selected></option>
            <option *ngFor="let listItem of landListItems"
                    value="{{ listItem.key }}">{{ listItem.value }}
            </option>
          </select>
          <ng-template #popover_antragsteller_einreisegenehmigung_endzielStaat>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Bitte tragen Sie hier den Endzielstaat ein.</span>
            </app-assistant>
          </ng-template>
        </div>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4">
        <div class="mb-3">
          <label
            for="antragsteller.einreisegenehmigung.ausgestelltVon"
            [class.mandatory]="isMandatory('ausgestelltVon')"
            i18n>Ausgestellt von:</label>
          <input id="antragsteller.einreisegenehmigung.ausgestelltVon"
                 type="text"
                 appToUpperCase
                 [attr.maxlength]="getMaxLength('ausgestelltVon')"
                 class="form-control form-control-sm"
                 [class.is-invalid]="errorClassRequired(form.controls['ausgestelltVon'])"
                 formControlName="ausgestelltVon"
                 [ngbPopover]="popover_antragsteller_einreisegenehmigung_ausgestelltVon"
                 appSaveLastFocussed
          >
          <ng-template #popover_antragsteller_einreisegenehmigung_ausgestelltVon>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Bitte tragen Sie hier ein, von wem die Einreiseerlaubnis ausgestellt wurde.</span>
            </app-assistant>
          </ng-template>
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-3">
          <label for="antragsteller.einreisegenehmigung.gueltigVon" i18n [class.mandatory]="isMandatory('gueltigVon')">Gültig von
            (TT.MM.JJJJ):</label>
          <input id="antragsteller.einreisegenehmigung.gueltigVon"
                 type="text"
                 appDynamicDateMaxLength
                 appFixDate="past" unknownReplacement="00"
                 class="form-control form-control-sm"
                 [class.is-invalid]="errorClassRequired(form.controls['gueltigVon'])"
                 formControlName="gueltigVon"
                 [ngbPopover]="popover_antragsteller_einreisegenehmigung_gueltigVon"
                 appSaveLastFocussed
          >
          <ng-template #popover_antragsteller_einreisegenehmigung_gueltigVon>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Bitte tragen Sie hier ein, ab welchem Datum die Einreiseerlaubnis gültig ist.</span>
            </app-assistant>
          </ng-template>
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-3">
          <label
            for="antragsteller.einreisegenehmigung.gueltigBis"
            i18n="@@gultig-bis-tt-mm-jjjj"
            [class.mandatory]="isMandatory('gueltigBis')">Gültig bis (TT.MM.JJJJ):</label>
          <input id="antragsteller.einreisegenehmigung.gueltigBis"
                 type="text"
                 appDynamicDateMaxLength
                 appFixDate="past" unknownReplacement="00"
                 class="form-control form-control-sm"
                 [class.is-invalid]="errorClassRequired(form.controls['gueltigBis'])"
                 formControlName="gueltigBis"
                 [ngbPopover]="popover_antragsteller_einreisegenehmigung_gueltigBis"
                 appSaveLastFocussed
          >
          <ng-template #popover_antragsteller_einreisegenehmigung_gueltigBis>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Bitte tragen Sie hier ein, bis zu welchem Datum die Einreiseerlaubnis gültig ist.</span>
            </app-assistant>
          </ng-template>
        </div>
      </div>

    </div>

  </div>
</div>
